{
    "sidebar": {
        "login": {
            "title": "Do air curtains really work?",
            "message": "YES! Air curtains a.k.a. air doors, properly selected, installed and operated really do work to create a barrier out of air across an opening. So much so, that ASHRAE Standard 90.1-2019 and the IECC building code allows air curtains as an alternative to vestibules."
        },
        "create-org": {
            "title": "Do air curtains really work?",
            "message": "YES! Air curtains a.k.a. air doors, properly selected, installed and operated really do work to create a barrier out of air across an opening. So much so, that ASHRAE Standard 90.1-2019 and the IECC building code allows air curtains as an alternative to vestibules."
        },
        "create-site": {
            "title": "Do air curtains really work?",
            "message": "YES! Air curtains a.k.a. air doors, properly selected, installed and operated really do work to create a barrier out of air across an opening. So much so, that ASHRAE Standard 90.1-2019 and the IECC building code allows air curtains as an alternative to vestibules."
        },
        "signup": {
            "title": "Are air curtains effective?",
            "message": "YES!\nEnergy Conservation & Comfort: Research shows that properly selected, installed and operated air curtains are +/- 80% effective at keeping warm air on one side and cold air on the other when the door is open."
        },
        "password-reset": {
            "title": "When is the Berner office open?",
            "message": "Monday - Friday 8:00 a.m. - 5:00 p.m. EST.\nClosed on major holidays."
        },
        "password-reset-validate": {
            "title": "When is the Berner office open?",
            "message": "Monday - Friday 8:00 a.m. - 5:00 p.m. EST.\nClosed on major holidays."
        }
    }
}